export const PASSTHRU_TIMEOUT_ERROR_MESSAGE = 'Unusually long passthru time'
export const HOTELS_DATA_NOT_FOUND_MESSAGE = 'Hotels data not found'
export const FETCH_SEARCH_IN_PLACE_HTTP_ERROR_400 =
	'Error in fetchSearchInPlace: Request failed with status code 400'
export const FETCH_SEARCH_IN_PLACE_HTTP_ERROR_PREFIX =
	'Error in fetchSearchInPlace: HTTP'
export const buildFetchSearchInPlaceHttpErrorMessage = (status: number) =>
	`${FETCH_SEARCH_IN_PLACE_HTTP_ERROR_PREFIX} ${status}`
export const FETCH_BY_DESTCODE_ERROR_PREFIX = 'Error in FetchByDestcode'
export const buildFetchByDestcodeErrorMessage = (message: string) =>
	`${FETCH_BY_DESTCODE_ERROR_PREFIX}: ${message}`
export const FETCH_HOTELS_ERROR_MESSAGE = 'Error in fetching hotels'
export const GA_DEGRADED_PAGE_VIEW_MESSAGE_SUFFIX = ' fired in degraded mode'
export const DIRECT_VIEW_GA_EVENT_MESSAGE = 'Direct view GA event fired'

const REPLAY_SKIP_MESSAGE_FRAGMENTS = [
	PASSTHRU_TIMEOUT_ERROR_MESSAGE,
	HOTELS_DATA_NOT_FOUND_MESSAGE,
	FETCH_SEARCH_IN_PLACE_HTTP_ERROR_400,
	FETCH_BY_DESTCODE_ERROR_PREFIX,
	FETCH_HOTELS_ERROR_MESSAGE,
	GA_DEGRADED_PAGE_VIEW_MESSAGE_SUFFIX,
	DIRECT_VIEW_GA_EVENT_MESSAGE,
] as const

export const getSentryEventErrorMessage = (event: {
	exception?: { values?: Array<{ value?: string }> }
	message?: string
}) => event.exception?.values?.[0]?.value ?? event.message ?? ''

export const shouldSkipReplayForError = (
	event: Parameters<typeof getSentryEventErrorMessage>[0]
): boolean => {
	const message = getSentryEventErrorMessage(event)
	return REPLAY_SKIP_MESSAGE_FRAGMENTS.some((fragment) =>
		message.includes(fragment)
	)
}
